import React from 'react'
import ReactDOM from 'react-dom'
import App from './App'
import themeConfig from './config/theme'
import { ThemeProvider } from '@material-ui/core/styles'
import { CssBaseline } from '@material-ui/core'
import './config/i18n'

ReactDOM.render(
  <React.StrictMode>
    <ThemeProvider theme={themeConfig}>
      <CssBaseline />
      <App />
    </ThemeProvider>
  </React.StrictMode>,
  document.getElementById('root')
)
